var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeedsAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#FFFAEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 7,
    width: 2,
    height: 10,
    fill: "#FEF0C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 16H12.75V11H11.25V16ZM11.9956 9.5C12.2069 9.5 12.3854 9.42855 12.5312 9.28565C12.6771 9.14273 12.75 8.96565 12.75 8.7544C12.75 8.54313 12.6785 8.36458 12.5356 8.21875C12.3927 8.07292 12.2156 8 12.0044 8C11.7931 8 11.6146 8.07145 11.4688 8.21435C11.3229 8.35727 11.25 8.53435 11.25 8.7456C11.25 8.95687 11.3215 9.13542 11.4644 9.28125C11.6073 9.42708 11.7844 9.5 11.9956 9.5ZM12.0058 20C10.9047 20 9.86806 19.7917 8.89583 19.375C7.92361 18.9583 7.07292 18.3854 6.34375 17.6562C5.61458 16.9271 5.04167 16.0767 4.625 15.105C4.20833 14.1334 4 13.0952 4 11.9905C4 10.8857 4.20833 9.85069 4.625 8.88542C5.04167 7.92014 5.61458 7.07292 6.34375 6.34375C7.07292 5.61458 7.92332 5.04167 8.89496 4.625C9.86661 4.20833 10.9048 4 12.0095 4C13.1143 4 14.1493 4.20833 15.1146 4.625C16.0799 5.04167 16.9271 5.61458 17.6562 6.34375C18.3854 7.07292 18.9583 7.92169 19.375 8.89008C19.7917 9.85849 20 10.8932 20 11.9943C20 13.0953 19.7917 14.1319 19.375 15.1042C18.9583 16.0764 18.3854 16.9271 17.6562 17.6562C16.9271 18.3854 16.0783 18.9583 15.1099 19.375C14.1415 19.7917 13.1068 20 12.0058 20Z",
    fill: "#B54708"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedsAttention);
export default __webpack_public_path__ + "static/media/needs_attention.3f783047283e5d1d85dce5071cb18295.svg";
export { ForwardRef as ReactComponent };